import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Projects from './components/Projects';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-gradient-to-b from-[#0a0a0a] to-[#1a1a1a] min-h-screen text-white">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-black/80 backdrop-blur-md border-b border-[#27272a]' : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-8 h-20 flex items-center justify-between">
          <a href="/" className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/903d1185-3412-4c16-b631-1d74fe95fb54.png" 
              alt="Omar Mohamed" 
              className="h-10 w-auto"
            />
          </a>
          <div className="flex items-center gap-12">
            <button
              onClick={() => scrollToSection('work')}
              className="text-[#a1a1aa] hover:text-[#14b8a6] transition-colors duration-300 text-sm tracking-wide cursor-pointer whitespace-nowrap"
            >
              WORK
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-[#a1a1aa] hover:text-[#14b8a6] transition-colors duration-300 text-sm tracking-wide cursor-pointer whitespace-nowrap"
            >
              ABOUT
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-[#a1a1aa] hover:text-[#14b8a6] transition-colors duration-300 text-sm tracking-wide cursor-pointer whitespace-nowrap"
            >
              CONTACT
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <Hero onExploreClick={() => scrollToSection('work')} />

      {/* Projects Section */}
      <Projects />

      {/* About Section */}
      <About />

      {/* Contact Section */}
      <Contact />

      {/* Footer */}
      <Footer />
    </div>
  );
}
